"use client";

import type { PropsWithChildren } from "react";
import { AuthProvider } from "./auth-provider";
import { OrgProvider } from "./org-provider";
import { DataRefreshProvider } from "./data-refresh-ctx";
import { ModalStateProvider } from "./modal-state-provider";
import { QueryProvider } from "@/providers/query-provider";
import { ToastProvider } from "@/components/ui/toast";
import { DialogProvider } from "@/ui/dialogs";

export default function Providers({ children }: PropsWithChildren) {

  return (
    <DataRefreshProvider>
      <QueryProvider>
        <ModalStateProvider>
          <ToastProvider>
            <DialogProvider>
              <AuthProvider>
                <OrgProvider>{children}</OrgProvider>
              </AuthProvider>
            </DialogProvider>
          </ToastProvider>
        </ModalStateProvider>
      </QueryProvider>
    </DataRefreshProvider>
  );
}
